import React from 'react'
import { Link } from 'react-router-dom';

const Item = ({ children, label, to, onClick }) => {

    if (onClick) {
        return (
            <a onClick={onClick} className='item item-sidebar'>
                <div>
                    {children}
                </div>
                <div>
                    <span className='label-sidebar-item'>{label}</span>
                </div>
            </a>
        )

    }

    return (
        <Link to={to} className='item item-sidebar'>
            <div>
                {children}
            </div>
            <div>
                <span className='label-sidebar-item'>{label}</span>
            </div>
        </Link>

    )
}


export default Item